import { BaseUrl } from "../network/networkSettings";
import axios from "axios";
import * as toast from "../components/Toast";
import helper from "../common/helper";
import CryptoJS from "crypto-js";

const ENCRYPTION_KEY = process.env.REACT_APP_ENCRYPTION_KEY;

export const decrypt = (data) => {
  try {
    const val = CryptoJS.AES.decrypt(
      data,
      ENCRYPTION_KEY
    ).toString(CryptoJS.enc.Utf8);
    return JSON.parse(val);
  } catch (err) {
    return data;
  }
};

export const encryptFormData = (body) => {
  var formData = body;
  if (formData.__proto__ == new FormData().__proto__)
    formData.set(
      "formData",
      JSON.stringify(encrypt(JSON.parse(formData.get("formData"))))
    );
  body = formData;
  return body;
};

export const encrypt = (body) => {
  if (
    ENCRYPTION_KEY &&
    typeof body == "object" &&
    Object.keys(body).length
  ) {
    body = {
      encData: CryptoJS.AES.encrypt(
        JSON.stringify(body),
        ENCRYPTION_KEY
      ).toString(),
    };
  } else if (
    ENCRYPTION_KEY &&
    typeof body == "string" &&
    body.length
  ) {
    body = {
      encData: CryptoJS.AES.encrypt(
        body,
        ENCRYPTION_KEY
      ),
    };
  }
  return body;
};

export const HttpCALLWithToken = async (
  method,
  type,
  token,
  body,
  params,
  receiveBlob
) => {
  return new Promise(async function (resolve, reject) {
    const url = BaseUrl + method;
    const auth = token === null ? "" : `Bearer ${token}`;
    const axiosConfig = {
      method: type,
      url: url,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: auth,
      },
      data: encrypt(body),
      params: params,
    };
    if (receiveBlob) axiosConfig.responseType = "blob";
    return axios(axiosConfig)
      .then((response) => {
        if (response.data.data?.encData) {
          response.data.data = decrypt(response.data.data.encData);
        }
        return resolve(response);
      })
      .catch((err) => {
        if (err.status === 403) {
          helper.SecureStorageFunc("userToken", "clear", "");
          // helper.SecureStorageFunc()
          window.location.assign("/login");
        }
        if (err.status === 402) {
          helper.SecureStorageFunc("userToken", "clear", "");

          err.message
            ? toast.error(err.message)
            : toast.error(
                "Your Organisation is not active. Please contact to admin."
              ); // ex:- CORS cross origin error
          window.location.assign("/login");
        }
        return reject(err.response?.data);
      });
  });
};

export const HttpCALLForExport = async (method, type, token, body) => {
  // return new Promise(async function (resolve, reject) {
  const url = BaseUrl + method;
  const auth = token === null ? "" : `Bearer ${token}`;
  return axios({
    method: type,
    url: url,
    responseType: "arraybuffer",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: auth,
    },
    data: encrypt(body),
  });
};

export const FormDataHttpCall = async (
  method,
  type,
  token,
  body,
  isExport = false
) => {
  return new Promise(async function (resolve, reject) {
    const url = BaseUrl + method;
    const auth = token === null ? "" : `Bearer ${token}`;
    const axiosObj = isExport
      ? {
          method: type,
          url: url,
          responseType: "arraybuffer",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: auth,
          },
          data: encryptFormData(body),
        }
      : {
          method: type,
          url: url,
          headers: {
            "content-type": false,
            Authorization: auth,
          },
          data: encryptFormData(body),
        };
    axios(axiosObj)
      .then((response) => {
        if (response.status === 200) {
          if (response?.data?.data?.encData) {
            response.data.data = decrypt(response.data.data.encData);
          }
          resolve(response);
        } else if (response.status === 201) {
          if (response?.data?.data?.encData) {
            response.data.data = decrypt(response.data.data.encData);
          }

          resolve(response);
        }
      })
      .catch((err) => {
        return reject(err.response.data);
      });
  });
};

export const handleError = (errorRes) => {
  const errorCode = errorRes?.code ? errorRes.code : errorRes?.status;
  if (errorRes?.data?.encData) {
    errorRes.data = decrypt(errorRes.data.encData);
  }
  if (errorCode) {
    switch (errorCode) {
      case 401:
        toast.error("Invalid username or password.");
        helper.SecureStorageFunc(null, "clear", null);
        break;
      case 403:
        var errorMsg = "";
        helper.SecureStorageFunc(null, "clear", null);
        if (errorRes.message !== "") {
          errorMsg = errorRes.message;
          //toast.error(errorRes.message);
        } else if (errorRes.detailedMessage !== "") {
          errorMsg = errorRes.detailedMessage;
          //toast.error(errorRes.detailedMessage);
        } else if (errorRes.data && errorRes.data.message !== "") {
          errorMsg = errorRes.data.message;
          //toast.error(errorRes.data.message);
        } else {
          errorMsg = "Something went wrong";
          //toast.error("Something went wrong");
        }
        setTimeout(() => {
          helper.SecureStorageFunc("userToken", "clear", "");
          window.location.assign("/login?error=" + errorMsg);
        }, 1000);
        //  window.location.href = "http://tims.hiteshi.com/";
        break;
      case 400:
      case 404:
      case 500:
      case 422:
      case 402:
      default:
        if (
          errorRes.message ===
          "This request was successfully processed except for the following items"
        ) {
          // show more info on partially failed request
          toast.error(
            `${errorRes.message} (${errorRes.detailedMessage}): ${errorRes.data}`
          );
        } else if (errorRes.detailedMessage) {
          toast.error(errorRes.detailedMessage);
        } else if (errorRes.message) {
          toast.error(errorRes.message);
        } else if (errorRes.data?.message) {
          toast.error(errorRes.data.message);
        } else {
          toast.error("Something went wrong");
        }
        break;
    }
  } else {
    toast.error("Something has gone wrong");
  }
};

export const HttpCallWithNonRepeatation = async (method, type, token, body) => {
  return new Promise(async function (resolve, reject) {
    const auth = token === null ? "" : `Bearer ${token}`;
    let url = BaseUrl + method;
    try {
      const res = await get(url, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: auth,
        },
      });
      if (res.data.data?.encData) {
        res.data.data = decrypt(res.data.data.encData);
      }
      return resolve(res);
    } catch (err) {
      return reject(err);
    }
  });
};

const makeRequestCreator = () => {
  let call;
  return (url, headers) => {
    if (call) {
      call.cancel();
    }
    call = axios.CancelToken.source();
    return axios.get(url, headers, {
      cancelToken: call.token,
    });
  };
};
const get = makeRequestCreator();
